<div *ngIf="singleLine">
  <span [className]="labelClass">
    {{ label | translate }}<span class="text-warning" *ngIf="required"> *</span><ng-container *ngIf="!noValue">:&nbsp;</ng-container>
  </span>
  <ng-container *ngIf="!noValue" [ngTemplateOutlet]="valueBlock"></ng-container>
</div>
<div *ngIf="!singleLine">
  <div [className]="labelClass" [ngClass]="{'no-margin': !withMargin, 'bottom-spacer': withMargin}">
    {{ label | translate }}
    <span class="text-warning" *ngIf="required">*</span>
    <mat-icon *ngIf="tooltip?.length" class="svg-icon text-grey" [svgIcon]="'info'" [matTooltip]="tooltip | translate"></mat-icon>
  </div>
  <ng-container *ngIf="!noValue" [ngTemplateOutlet]="valueBlock"></ng-container>
</div>

<ng-template #valueBlock>
  <ng-container *ngIf="!template">
    <ng-container *ngIf="!link || !value">{{ (value | translateValue) || '-' }}</ng-container>
    <app-link *ngIf="link && value" [link]="value" [wrap]="openTab" [blankTarget]="openTab"
              [icon]="icon" [inlineFlex]="singleLine" (linkClicked)="linkAction.emit()"></app-link>
  </ng-container>
  <ng-container *ngIf="template">
    <ng-container *ngIf="empty">{{ '-' }}</ng-container>
    <ng-container *ngIf="!empty" [ngTemplateOutlet]="template"></ng-container>
  </ng-container>
</ng-template>
